import { Expose } from "class-transformer";

export class OutsourcingDto {
  @Expose()
  isOutsourcing: boolean;

  @Expose()
  comments?: string;
}
